/* eslint-disable import/no-default-export */
import React from 'react';
import styles from './link.less';

interface LinkProps {
  children: React.ReactNode;
  link: string;
  onClick?: React.EventHandler<React.MouseEvent<HTMLElement>>;
}

const PrimaryLinkButton = ({ children, link, onClick }: LinkProps) => {
  return (
    <a href={link} className={styles.primaryLinkButton} onClick={onClick}>
      {children}
    </a>
  );
};

export default PrimaryLinkButton;



// WEBPACK FOOTER //
// ./app/common/components/controls/link/link.tsx